'use strict';

import $ from 'jquery';
import { viewport } from './utilities/viewport';
import { debounce } from './utilities/debounce';

let homeQuickLinksTitle = $('#block-homequicklinks .field--name-field-title');
let homeQuickLinksItem = $('#block-homequicklinks .field--name-field-quick-link-contents > .field__item');
let landingMenuTitle = $('#-menu');
let submissionStagesHeader = $('.standard-page-content .stage-header');

homeQuickLinksTitle.on('click', function(){
	if ( viewport().width < 760 ) {
		$(this).toggleClass('expanded');
		$(this).next().slideToggle(300);
	}
})

landingMenuTitle.on('click', function(){
	if ( viewport().width < 1070 ) {
		$(this).toggleClass('expanded');
		$(this).next().slideToggle(300);
	}
})

$('.standard-page-content .stage-header').on('click', function(){
	if ( viewport().width < 1070 ) {
		$(this).toggleClass('expanded');
		$(this).next().slideToggle(300);
		if($(this).attr('aria-expanded') == 'true'){
			$(this).attr('aria-expanded','false');
		} else {
			$(this).attr('aria-expanded','true');
		}
	}
})

$(window).on('resize', debounce(function(){
	if ( viewport().width > 760 ) {
		homeQuickLinksTitle.next().css('display', 'flex');
	} else {
		if (!homeQuickLinksTitle.hasClass('expanded')){
			homeQuickLinksTitle.next().css('display', 'none');
		}
	}

	if ( viewport().width > 1070 ) {
		landingMenuTitle.next().css('display', 'block');
	} else {
		if (!landingMenuTitle.hasClass('expanded')){
			landingMenuTitle.next().css('display', 'none');
		}
	}

	submissionStagesHeader.each(function(){
		if ( viewport().width > 1070 ) {
			$(this).next().css('display', 'block');
		} else {
			if (!$(this).hasClass('expanded')){
				$(this).next().css('display', 'none');
			}
		}
	})

}, 250));

homeQuickLinksItem.on('click', function(){
	window.location.href = $(this).find('a').attr('href');
})
